import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import "./index.css";

const HistorialActuaciones = ({ show, handleClose, data }) => {
  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        className=""
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className="px-5">
          <div className="d-flex w-full align-items-center justify-content-between">
            <div>
              <b>
                HISTORIAL ACTUACIONES
              </b>
            </div>
          </div>
          <div className="mt-3">
            <Row >
              <Col md={4} className="p-3"><b>FECHA INICIAL</b></Col>
              <Col md={4} className="p-3"><b>ETAPA</b></Col>
              <Col md={4} className="p-3"><b>OBSERVACIÓN</b></Col>
            </Row>
            {data.historico && (
              <Row className={"d-flex actuacion-row"} >
                <Col md={4} className="p-3">{data.historico.FECHA }</Col>
                <Col md={4} className="p-3">{data.historico.SITUACION}</Col>
                <Col md={4} className="p-3"></Col>
              </Row>
            )}

            {data?.actuaciones?.length ? data.actuaciones.map((e, i) => {
              let fecha = "";

              if (e.fecha) {
                const [year, month, day] = e.fecha.split("-");
                fecha = `${day}/${month}/${year}`;
              }
              return (
                <Row className={`d-flex ${i || data.historico ? "actuacion-row" : ""}`} key={`actuacion-${i}`}>
                  <Col md={4} className="p-3">{e.FECHA || fecha}</Col>
                  <Col md={4} className="p-3">{e.SITUACION || e.tipo_etapa.nombre}</Col>
                  <Col md={4} className="p-3">{e.obs}</Col>
                </Row>
              );
            }) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HistorialActuaciones;
